export function AdminRoster() {
  return (
    <div className="max-w-6xl mx-auto px-6 py-10">
      <h1 className="text-2xl tracking-tight">Roster</h1>
      <p className="text-[color:var(--mute)] mt-2">Engineer roster, policies, and per-user budgets. Implementation lands in v3.1.</p>
    </div>
  );
}
